import { render, staticRenderFns } from "./ContHandlingType.vue?vue&type=template&id=4e3ca6e5&scoped=true&"
import script from "./ContHandlingType.vue?vue&type=script&lang=js&"
export * from "./ContHandlingType.vue?vue&type=script&lang=js&"
import style0 from "./ContHandlingType.vue?vue&type=style&index=0&id=4e3ca6e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3ca6e5",
  null
  
)

export default component.exports